export const DOWNLOAD_MAC_URL =
  import.meta.env.VITE_DOWNLOAD_MAC_URL ||
  'https://arvid-api.onrender.com/api/updates/mac/download';
